import { mapScreenSteerToTrack } from "./steering";

export type GamepadDriveSample = {
  throttle: number;
  brake: number;
  steer: number;
  drift: boolean;
  boost: boolean;
};

export type GamepadEdgeSample = {
  start: boolean;
  pause: boolean;
  camera: boolean;
  recover: boolean;
};

type GamepadSample = Pick<Gamepad, "axes" | "buttons">;

export const sampleStandardGamepadDrive = (
  gamepad: GamepadSample | null | undefined
): GamepadDriveSample => ({
  throttle: gamepad?.buttons[7]?.value ?? 0,
  brake: Math.max(
    gamepad?.buttons[6]?.value ?? 0,
    Number(gamepad?.buttons[1]?.pressed ?? false)
  ),
  steer: mapScreenSteerToTrack(gamepad?.axes[0] ?? 0),
  drift: Boolean(gamepad?.buttons[0]?.pressed),
  boost: Boolean(gamepad?.buttons[2]?.pressed)
});

export const sampleStandardGamepadEdges = (
  current: readonly boolean[],
  previous: readonly boolean[]
): GamepadEdgeSample => {
  const rose = (index: number): boolean => current[index] === true && previous[index] !== true;
  const menuButton = rose(9);
  return {
    start: menuButton,
    pause: menuButton,
    camera: rose(3),
    recover: rose(8)
  };
};
